import { Img } from "components";
import React from "react";
import { motion } from "framer-motion";

// Animation variants
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.3
    }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};

const imageVariants = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.7,
      ease: [0.16, 1, 0.3, 1]
    }
  }
};

const buttonVariants = {
  initial: { backgroundColor: "#31343a" },
  hover: { 
    scale: 1.05, 
    backgroundColor: "#424956",
    boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.2)",
    transition: { duration: 0.3 }
  },
  tap: { 
    scale: 0.98,
    transition: { duration: 0.1 }
  }
};

const TheFirstKind = () => {
  return (
    <motion.div 
      className="w-full bg-black relative pt-[45px] sm:pt-[60px] md:pt-[65px] lg:pt-[130px] xl:pt-[130px] pb-[65px]"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      variants={containerVariants}
    >
      {/* Background elements with animation */}
      <motion.div
        variants={itemVariants}
        className="absolute left-[15px] sm:left-[37px] md:left-[37px] lg:left-[37px] -top-[17px] sm:-top-11 md:-top-11 lg:-top-11"
        animate={{
          rotate: [0, 5, 0, -5, 0],
          transition: { 
            repeat: Infinity, 
            duration: 10,
            ease: "easeInOut"
          }
        }}
      >
        <Img
          src="/images/yellow-vector.png"
          className="w-8 xs:w-12 md:w-18 lg:w-24"
        />
      </motion.div>

      {/* Content container with padding */}
      <div className="grid md:grid-cols-2 grid-cols-1 lg:w-10/12 xl:w-10/12 container md:w-11/12 px-[15px] sm:px-0 md:px-0 lg:px-0 mx-auto h-full gap-y-8 md:gap-y-4">
        {/* Image Section - Displayed first on mobile */}
        <motion.div 
          className="flex justify-center md:justify-end lg:justify-end xl:justify-end items-center md:order-2"
          variants={imageVariants}
        >
          <Img 
            src="/images/the_first_kind_v2.png" 
            className="md:w-10/12 w-3/4"
            style={{ filter: "drop-shadow(0 20px 30px rgba(0,0,0,0.25))" }}
          />
        </motion.div>

        {/* Text Content Section */}
        <motion.div 
          className="flex justify-center flex-col md:items-start items-center h-full text-white-0"
          variants={itemVariants}
        >
          <motion.h2 
            className="first-kind font-bold text-[20px] sm:text-[24px] md:text-[30px] lg:text-[44px] xl:text-[44px] pt[2.5rem] pb-[24px] mb-0 pr-0 sm:pr-0 md:pr-0 lg:pr-[60px]"
            variants={itemVariants}
            style={{
              textShadow: "0 2px 4px rgba(0,0,0,0.2)",
              letterSpacing: "0.02em"
            }}
          >
            Join now to secure your spot as an influencer or audience member.
          </motion.h2>
          
          <motion.button 
            className="px-7 py-3 text-white rounded-full text-xl w-[228px] h-[60px] focus:outline-none relative overflow-hidden"
            variants={buttonVariants}
            initial="initial"
            whileHover="hover"
            whileTap="tap"
            style={{ 
              backgroundColor: "#31343a",
              boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
              position: "relative",
              transform: "translateZ(0)"
            }}
          >
            {/* Subtle animated gradient overlay */}
            <motion.div 
              className="absolute inset-0 opacity-0 z-0" 
              style={{
                background: "linear-gradient(45deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 70%)",
              }}
              animate={{
                opacity: [0, 0.5, 0],
                left: ["-100%", "100%", "100%"]
              }}
              transition={{
                duration: 2,
                ease: "easeInOut",
                repeat: Infinity,
                repeatDelay: 2
              }}
            />
            <span className="relative z-10 font-medium">Coming Soon</span>
          </motion.button>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default TheFirstKind;



